const plusItems = [
  "24/7 text support from nurses and <nobr>peer coaches</nobr>",
  "Weekly personalized fertility tips <nobr>from experts</nobr>",
  "Fertility info in skimmable, <nobr>bite-sized pieces</nobr>",
  "Referrals to <nobr>top doctors</nobr>",
];
const plusIntro =
  "Evidence-based advice, whenever you need it. For less than a <nobr>dollar a day.</nobr>";

const premiumItems = [
  "Weekly virtual peer group sessions, <nobr>led by a coach</nobr>",
  "1:1 sessions with your dedicated fertility nurse and peer coach, by phone, <nobr>video chat, or text.</nobr>",
  "Weekly sessions with top providers in the industry—from fertility specialists like REIs to embryologists.",
  "A personalized fertility plan to take to <nobr>your medical team.</nobr>",
  "Money-saving tips from financial experts—to help you get the most of out of your insurance or identify <nobr>other ways to pay</nobr>",
  "Early access to new <nobr>products and discounts</nobr>",
];
const premiumIntro =
  "A full-service fertility support network for less than the cost of a latte a day.";

const premiumPrice = "$129/mo";
const plusPrice = "$49/mo";

export const membershipSelect = {
  bgDesign: "Background illustration",
  cantDecide:
    "<Strong>Can't decide?</Strong> <nobr><Link>Read more about our plans here</Link></nobr>",
  payment: {
    premium: {
      cta: "Select",
      intro: premiumIntro,
      items: premiumItems,
      price: premiumPrice,
    },
    plus: {
      cta: "Select",
      intro: plusIntro,
      items: plusItems,
      price: plusPrice,
    },
    title: "Select your plan",
  },
  resubscribe: {
    premium: {
      cta: "Subscribe",
      intro: premiumIntro,
      items: premiumItems,
      price: premiumPrice,
    },
    plus: {
      cta: "Subscribe",
      intro: plusIntro,
      items: plusItems,
      price: plusPrice,
    },
    subtitle: "Select your plan",
    title: "Welcome back!",
  },
  upgrade: {
    premium: {
      cta: "Upgrade to Premium",
      intro: premiumIntro,
      items: premiumItems,
      price: premiumPrice,
    },
    plus: {
      cta: "Current Plan",
      intro: plusIntro,
      items: plusItems,
      price: plusPrice,
    },
    subtitle: "",
    title: "Upgrade your plan",
  },
};
